import getDomain from '../helpers/getDomain';
import axios from 'axios';
import React, { useState, createContext, useCallback } from 'react';

export const ModalContext = createContext();

export const ModalProvider = (props) => {
  const [modal, setModal] = useState(null);

  const activateModal = useCallback(async (data) => {
    axios
      .get(getDomain() + '/api/fact/')
      .then((fact) => {
        if (data.disableBasket) {
          axios
            .get(
              getDomain() +
                `/api/products/${data.selectedStone.id}/sponsor-details`
            )
            .then((sponsorDetails) => {
              setModal({
                ...data,
                fact: fact.data,
                sponsorName: sponsorDetails.data.name,
                sponsorPublicStatus: sponsorDetails.data.publicStatus,
              });
            })
            .catch((error) => {
              if (error.response) {
                console.error(error.response.data);
              } else if (error.request) {
                console.error(error.request);
              } else {
                console.error('Error', error.message);
              }
            });
        } else {
          setModal({ ...data, fact: fact.data });
        }
      })
      .catch((error) => {
        if (error.response) {
          console.error(error.response.data);
        } else if (error.request) {
          console.error(error.request);
        } else {
          console.error('Error', error.message);
        }
      });
  }, []);

  const deactivateModal = useCallback(() => {
    setModal(null);
  }, []);

  return (
    <ModalContext.Provider value={[modal, activateModal, deactivateModal]}>
      {props.children}
    </ModalContext.Provider>
  );
};
